<template>
  <div id="app" @mouseover="updateHoverFirstState" :data-infopanel="$store.state.infoPanelDeployed">
    <section class="TitleCtn">
      <div class="TitleCtn__desktop">
        <IconButton
          icon="burger"
          id="menu"
          v-on:clicked="toggleResponsiveMenu"
          :is-triggerable="true"
          :data-active="this.$store.state.iframe"
          :data-no-bg="true"
          :active="this.$store.state.iframe"
          />
        <h1 v-html="this.words[this.$store.state.language.lang].general.Title"></h1>
        <Translator/>
      </div>
      <IconButton
        icon="search"
        id="search"
        v-on:clicked="toggleSearchBar"
        :is-triggerable="true"
        :data-no-bg="true"
        :data-active="this.$store.state.searchBar"
        />
      <IconButton
        icon="close"
        v-on:clicked="toggleSidebar"
        :is-triggerable="true"
        :data-active="this.$store.state.infoPanelDeployed"
        :active="this.$store.state.infoPanelDeployed"
        id="toggle_navbar"
        />
    </section>
    <section id="geoapp">
      <Navbar/>
      <Map/>
    </section>
  </div>
</template>

<script>

import { words } from '@/constants/lang'
import Navbar from './components/Navbar.vue'
import Map from './components/Map.vue'
import IconButton from './components/IconButton.vue'
import Translator from './components/Translator.vue'

export default {
  name: 'App',
  components: {
    Map, Navbar, Translator, IconButton
  },
  data: () => ({
    words
  }),
  watch: {
    '$store.state.fullscreen': function() {
      this.$store.state.fullscreen ? this.goFullscreen() : this.exitFullscreen();
    },
  },
  methods: {
    updateHoverFirstState: function () {
      let self = this;
      setTimeout(function () {
        self.$store.commit('updateHoverFirstState');
      }, 4000)
    },
    toggleSearchBar: function () {
      this.$store.commit('toggleSearchBar')
      let searchBar = document.querySelector('.mapboxgl-ctrl-geocoder input');
      this.$store.state.searchBar ? searchBar.focus() : searchBar.blur();
      searchBar.value = "";
    },
    toggleResponsiveMenu: function () {
      this.$store.commit('toggleResponsiveMenu')
    },
    goFullscreen: function () {
      let elem = document.getElementById('geoapp');
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
      }
    },
    exitFullscreen: function () {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen();
      }
    },
    toggleSidebar: function () {
      let self = this;
      this.$store.commit('toggleInfoPanel')
      setTimeout(function() {self.$store.commit('updateActiveCountry', null)},350)
    },
  }
}
</script>

<style lang="less">

@import "less/_var.less";

*:focus {
  outline: none;
}

::selection {
  background-color: #6aa6a8;
  color: white;
}

html, body {
  margin: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-x: hidden;
}
@dim-title-h-destop: 60px;
#app {
  font-family: @font-secondary;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #111;
  background: white;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  display: flex;
  flex-flow: column;
  justify-content: space-between;

  .TitleCtn {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    padding: 0;
    background: white;
    z-index: 4;
    position: relative;
    height: @dim-title-h-destop;
    min-height: @dim-title-h-destop;

    .TitleCtn__desktop {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      flex: 1 0 auto;

      #menu {
        visibility: hidden;
        min-width: 150px;
      }

      h1 {
        font-size: 1.6em;
        font-family: @font-primary;
        font-weight: 100;
        margin: 0;
      }
    }

    #search, #toggle_navbar {
      display: none;
    }
  }

  #geoapp {
    flex: 1 0 auto;
    display: flex;
    flex-flow: column nowrap;
    height: calc(100% - @dim-title-h-destop);
    min-height: calc(100% - @dim-title-h-destop);

    .Map {
      height: calc(100% - @dim-navbar);
      width: 100%;
    }
  }
}

.show-sm { display: none; }

@media screen and (max-width: 1100px) {
  .hide-md { display: none; }
}

@media screen and (max-width: 640px) {

  .hide-sm { display: none; }
  .show-sm { display: inherit; }

  @dim-title-h-mobile: 50px;

  #app {
    .TitleCtn {
      padding: 0;
      height: @dim-title-h-mobile;
      min-height: @dim-title-h-mobile;
      border-bottom: solid 1px #ddd;
      box-sizing: border-box;

      .TitleCtn__desktop {
        justify-content: flex-start;
        align-items: center;

        h1 { line-height: 0em; }

        #menu {
          visibility: visible;
          margin: 0 10px 0 15px;
          min-width: inherit;
        }
        .Translator {
          display: none;
        }
      }

      #search {
        display: inherit;
        margin-right: 8px;
      }

      .IconButton[is-triggerable][data-active=true] {
        &#toggle_navbar {
          width: 40px;
          min-width: 40px;
          opacity: 1;
        }
      }
      #toggle_navbar {
        width: 0px;
        min-width: 0;
        background: #cdcdcd !important;
        opacity: 0;
        height: calc(100% + 1px);
        border-radius: 0ch;
        border: none;
        display: inherit;
      }
    }

    #geoapp {
      height: calc(100% - @dim-title-h-mobile);
      min-height: calc(100% - @dim-title-h-mobile);

      .Map {
        height: 100%;
        min-height: 100%;

        .ECPMSwitch__ctn {
          display: flex;
          flex-flow: row nowrap;
          transform: translateY(0);
          transition: transform .15s ease-in-out;
          position: absolute;
          top: 0;
          height: 36px;
          width: 100%;
          border-bottom: solid 1px #ddd;

          .ECPMSwitch {
            padding: 4px 11px 2px 11px;

            .IconButton__icon {
              margin-right: 0;
            }
            .Checkbox {
              margin-left: 6px;
            }
          }

          .IGOSwitch {
            z-index: 2;
            flex: 1 0 auto;

            &__list {
              overflow-y: inherit;
              max-height: inherit;

              li:first-child {
                margin-top: 0px;
                border-radius: 0;
              }
            }

            button {
              border: none;
              border-radius: 0;
              box-shadow: none;
              border-left: solid 1px #ddd;
              border-bottom: solid 1px #ddd;
              padding: 12px 12px 10px 8px;
            }
          }
          .ECPMSwitch, .IGOSwitch {
            position: relative;
            top: 0;
            left: 0;
            height: 100%;
            border: none;
            box-shadow: none;
            border-radius: 0;
            border-bottom: solid 1px #ddd;
          }
        }
        .mapboxgl-ctrl-geocoder {
          box-shadow: none;
          .mapboxgl-ctrl-geocoder--icon-search {
            top: 10px;
          }
          .mapboxgl-ctrl-geocoder--icon-close {
            margin-top: 5px;
          }
          .mapboxgl-ctrl-geocoder--input {
            font-size: 0.75em;
            height: 44px;
          }
        }

        &[data-search=true] {
          .mapboxgl-ctrl-geocoder {
            border-bottom: solid 1px #ddd;
          }
          .ECPMSwitch__ctn {
            transform: translateY(44px);
          }
        }
      }
    }
  }
}

</style>
